// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__N_nZP","col":"styles_col__1ljBf"};